module.exports = {
      id: "illustrations:AU02-usage",
      viewBox: "0 0 263 231",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:AU02-usage",
      toString: function () {
        return this.url;
      }
    }